<template>
    <v-btn v-bind="{ color, ...$attrs }" icon outlined @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </v-btn>
</template>

<script>
export default {
    props: {
        color: { type: String, default: "grey" },
    },
    components: {},
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
